import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface PickerItem {
  id: any;
  label: string;
  sublabel?: string;
}

/**
 * Újrahasználható, kereshető választó modal nagy listákhoz (csoportok,
 * osztályok stb.). Az `ion-select` popover/alert nagy (több száz elemű)
 * listáknál lefagyasztja az oldalt, mert egyszerre rendereli az összes
 * opciót. Ez a modal helyette keres + csak az első néhány találatot
 * jeleníti meg, így nem fagy.
 *
 * Egyválasztós módban a tételre kattintva azonnal visszatér; többválasztós
 * módban checkboxokkal gyűjt, és a „Kész” gombbal zár.
 */
@Component({
  selector: 'app-entity-picker-modal',
  templateUrl: './entity-picker-modal.component.html',
  styleUrls: ['./entity-picker-modal.component.scss'],
})
export class EntityPickerModalComponent implements OnInit {
  @Input() items: PickerItem[] = [];
  @Input() multiple = false;
  @Input() selectedIds: any[] = [];
  @Input() title = 'Választás';
  @Input() searchPlaceholder = 'Keresés…';

  kereses = '';
  szurt: PickerItem[] = [];
  selectedSet = new Set<any>();
  truncated = 0;
  readonly MAX = 80;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    this.selectedSet = new Set((this.selectedIds || []).map((x) => String(x)));
    this.szures();
  }

  szures() {
    const q = this.kereses.trim().toLowerCase();
    const matches = q
      ? this.items.filter((i) =>
          (i.label + ' ' + (i.sublabel || '')).toLowerCase().includes(q)
        )
      : this.items;
    this.truncated = Math.max(0, matches.length - this.MAX);
    this.szurt = matches.slice(0, this.MAX);
  }

  isSelected(id: any): boolean {
    return this.selectedSet.has(String(id));
  }

  valaszt(item: PickerItem) {
    const key = String(item.id);
    if (this.multiple) {
      if (this.selectedSet.has(key)) {
        this.selectedSet.delete(key);
      } else {
        this.selectedSet.add(key);
      }
    } else {
      this.modalCtrl.dismiss({ ids: [item.id] }, 'confirm');
    }
  }

  megerosit() {
    // A kijelölt id-ket az eredeti típusukban adjuk vissza.
    const ids = this.items
      .filter((i) => this.selectedSet.has(String(i.id)))
      .map((i) => i.id);
    this.modalCtrl.dismiss({ ids }, 'confirm');
  }

  megse() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  trackById(_: number, item: PickerItem) {
    return item.id;
  }
}
